import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { api, setToken, clearToken, formatApiErrorDetail } from "@/app/api";
import { attributeStoredReferral } from "@/lib/referral";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=guest, obj=auth

  useEffect(() => {
    let active = true;
    api.get("/auth/me").then((r) => active && setUser(r.data)).catch(() => active && setUser(null));
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      setUser(data.user);
      attributeStoredReferral();
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      setToken(data.access_token);
      setUser(data.user);
      attributeStoredReferral();
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => { clearToken(); setUser(null); };

  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
}

export function ProtectedRoute({ roles }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex min-h-screen items-center justify-center text-slatey">Loading…</div>;
  if (!user) return <Navigate to="/app/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return <Outlet />;
}
